import { styled } from "@mui/material/styles";

const MyQuotesTableMain = styled("div")(({ theme }) => ({
  "& .TableWrapper ": {
    marginTop: "0px",
  },
}));

export { MyQuotesTableMain };
